// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2n9uv","placeholdersHeader":"styles_placeholdersHeader__3wAQ5","editorStyle":"styles_editorStyle__14rgT","placeholdersBox":"styles_placeholdersBox__2IOQX"};